import { FC, useState } from 'react';
import { Title } from 'components/Title';
import { ReactComponent as NoPhotoSvg } from 'assets/img/worker/noPhoto.svg';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Field } from 'ui/Field';
import { InputMask } from 'components/InputMask';
import styles from './MainInfo.module.scss';
import { Button } from 'ui/Button';
import { Modal } from 'components/Modal';
import modalStyles from './WorkerContentModal.module.scss';
import { useParams } from 'react-router';

export const MainInfo: FC = () => {
  const { infoEmployeds } = useSelector((state: RootState) => state.employedsDetailSlice);
  const { phone, surname, name, patronymic, sex, dob, avatar, is_deleted } =
    infoEmployeds || {};
  const { id } = useParams();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);
  const [actionTitle, setActionTitle] = useState('');

  const showConfirmation = (action: () => void, title: string) => {
    setPendingAction(() => action);
    setActionTitle(title);
    setConfirmationModal(true);
  };

  const confirmAction = () => {
    if (pendingAction) {
      pendingAction();
    }
    setConfirmationModal(false);
    setPendingAction(null);
  };

  const cancelAction = () => {
    setConfirmationModal(false);
    setPendingAction(null);
  };

  const sendDataSubmittingModerationChangeHandler = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/worksupport/workers-app/${id}/add-to-moderation-pool`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );

      const data = await response.json();

      if (response.ok) {
        setModalMessage(data.message);
      } else {
        setModalMessage(data.message);
      }
    } catch {
      setModalMessage(
        `Произошла ошибка при отправке на модерацию, повторите запрос позднее`,
      );
    }
    setModalOpen(true);
  };

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Title title='Исполнитель' />
        {is_deleted && <p>Профиль удален</p>}
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.inputs}>
            <Field title={surname} placeholder='Фамилия' />
            <Field title={name} placeholder='Имя' />
            <Field title={patronymic} placeholder='Отчество' />
            <div className={styles.phone}>
              <InputMask
                width
                value={phone}
                setValue={() => {
                  // check(value);
                }}
                placeholder='Телефон'
                type='tel'
              />
            </div>
            <Field width title={sex ? 'Мужской' : 'Женский'} placeholder='Пол' />
            <Field width title={dob ? dob : 'дд.мм.гггг'} placeholder='Дата рождения' />
          </div>
          <div className={styles.avatarContainer}>
            {!avatar ? (
              <NoPhotoSvg />
            ) : (
              <img src={avatar} className={styles.avatar}></img>
            )}
            <Button
              onClick={() =>
                showConfirmation(
                  sendDataSubmittingModerationChangeHandler,
                  'Отправить исполнителя в очередь на модерацию?',
                )
              }
              className={styles.moderationButton}
              theme='filed'
              size='L'>
              Отправить на модерацию
            </Button>
          </div>
          {modalOpen && (
            <Modal setOpen={setModalOpen}>
              <div className={modalStyles.root}>
                <Title className={modalStyles.title} title='Уведомление' />
                <p className={modalStyles.message}>{modalMessage}</p>
                <div className={modalStyles.buttons}>
                  <Button
                    onClick={() => setModalOpen(false)}
                    className={modalStyles.button}
                    theme='filed'>
                    Закрыть
                  </Button>
                </div>
              </div>
            </Modal>
          )}
          {confirmationModal && (
            <Modal setOpen={setConfirmationModal}>
              <div className={modalStyles.root}>
                <Title className={modalStyles.title} title='Подтверди отправку' />
                <p className={modalStyles.message}>{actionTitle}</p>
                <div className={modalStyles.buttons} style={{ gap: '12px' }}>
                  <Button
                    onClick={confirmAction}
                    className={modalStyles.button}
                    theme='filed'>
                    Подтвердить
                  </Button>
                  <Button
                    onClick={cancelAction}
                    theme='danger'
                    className={modalStyles.button_cancel}>
                    Отмена
                  </Button>
                </div>
              </div>
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
};
